import { Controller } from "@hotwired/stimulus"
import Choices from 'choices.js'

export default class extends Controller {
  static values = {
    input: Boolean,
    options: Array,
    selectedOptions: Array,
    attributeElementId: String,
    singleSelect: Boolean,
    clearable: Boolean,
    placeholder: String,
    resourceTypes: Object
  }

  getIconForType(type) {
    if (type === 'VideoResource') {
      return '<svg class="w-3.5 h-3.5 mr-1 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"></path></svg>';
    } else if (type === 'AudioResource') {
      return '<svg class="w-3.5 h-3.5 mr-1 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z"></path></svg>';
    } else if (type === 'DailySchedule') {
      return '<svg class="w-3.5 h-3.5 mr-1 text-frankly-bluegreen-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>';
    } else if (type === 'Collection') {
      return '<svg class="w-3.5 h-3.5 mr-1 text-frankly-olive-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"></path></svg>';
    } else if (type === 'CollectionGroup') {
      return '<svg class="w-3.5 h-3.5 mr-1 text-frankly-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zm10 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zm10 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"></path></svg>';
    } else if (type === 'DocumentResource') {
      return '<svg class="w-3.5 h-3.5 mr-1 text-frankly-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path></svg>';
    } else if (type === 'LinkResource') {
      return '<svg class="w-3.5 h-3.5 mr-1 text-frankly-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"></path></svg>';
    }
    return '';
  }

  getColorClassesForType(type) {
    if (type === 'VideoResource') {
      return 'bg-purple-100 border-purple-300 text-purple-800';
    } else if (type === 'AudioResource') {
      return 'bg-blue-100 border-blue-300 text-blue-800';
    } else if (type === 'DailySchedule') {
      return 'bg-frankly-bluegreen-100 border-frankly-bluegreen-300 text-frankly-bluegreen-800';
    } else if (type === 'Collection') {
      return 'bg-frankly-olive-100 border-frankly-olive-300 text-frankly-olive-800';
    } else if (type === 'CollectionGroup') {
      return 'bg-frankly-orange-100 border-frankly-orange-300 text-frankly-orange-800';
    } else if (type === 'DocumentResource') {
      return 'bg-frankly-orange-100 border-frankly-orange-300 text-frankly-orange-800';
    } else if (type === 'LinkResource') {
      return 'bg-frankly-green-100 border-frankly-green-300 text-frankly-green-800';
    }
    return 'bg-gray-200 border-gray-400 text-gray-800';
  }

  getResourceMetadata(value) {
    return this.resourceTypesValue?.[value]
  }

  getResourceType(value) {
    const metadata = this.getResourceMetadata(value)
    if (!metadata) return null
    if (typeof metadata === 'string') return metadata
    return metadata.type || null
  }

  isPublicVideoResource(value) {
    const metadata = this.getResourceMetadata(value)
    if (!metadata || typeof metadata === 'string') return false

    const resourceType = metadata.type
    const publicAccess = metadata.public_access ?? metadata.publicAccess

    return resourceType === 'VideoResource' && publicAccess === true
  }

  addPublicAccessIcon(element) {
    if (element.querySelector('.public-access-eye')) return

    const eyeIconHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="public-access-eye w-3.5 h-3.5 mr-1 text-gray-700" viewBox="0 0 16 16"><path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"/><path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"/></svg>'

    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = eyeIconHTML
    const eyeIcon = tempDiv.firstElementChild
    element.insertBefore(eyeIcon, element.firstChild)
  }

  connect() {
    // Choices is very particular.  An error is thrown when trying to sort by default sort if you pass in
    // items(options)/choices(selections) to be loaded.  Instead of using those I opted to create the select/options via
    // rails to instantiate it.  It also looks like a multiple select won't work for adding new entries,
    // as you need a standard input for that.  Since the only use case we have at the moment for that is for labels,
    // I'll create a flag to pass as a data value to signal to the controller to add that option and render differently
    // in the component
    const choices_options = this.singleSelectValue ? {
      classNames: {
        inputCloned: ['choices__input--cloned', '!min-w-10'],
        itemSelectable: ['!font-semibold', '!text-black'],
        listDropdown: ['choices__list--dropdown', '!bg-white'],
      },
      placeholder: this.clearableValue,
      searchPlaceholderValue: this.hasPlaceholderValue ? this.placeholderValue : '',
      removeItemIconText: '×',
      removeItemLabelText: '',
      searchEnabled: true,
      removeItemButton: this.clearableValue || this.hasPlaceholderValue,
    } : {
      classNames: {
        // The '!min-w-10' clamp forces the search input to a fixed 40px min-width via
        // !important, which beats Choices' own inline `min-width: <placeholder length>ch`
        // and truncates a real placeholder down to a few characters. Only current caller
        // with a multi-select placeholder is admin/users filters; skip the clamp there so
        // the full placeholder text can show, and keep it everywhere else unchanged.
        inputCloned: this.hasPlaceholderValue ? ['choices__input--cloned'] : ['choices__input--cloned', '!min-w-10'],
        itemSelectable: ['!font-semibold', '!text-black'],
        listDropdown: ['choices__list--dropdown', '!bg-white'],
        listItems: ['choices__list--multiple', '!bg-white'],
        item: ['!inline-flex', '!items-center', '!w-auto', '!bg-gray-200', '!text-gray-800', '!border', '!border-gray-400', '!rounded', '!px-2', '!py-0.5', '!font-medium', '!text-xs', '!mr-2', '!mb-1'],
        button: ['!bg-transparent', '!border-none', '!border-l', '!border-gray-400', '!pl-1.5', '!ml-1.5', '!text-gray-700', 'hover:!text-gray-900', '!font-bold', '!text-base']
      },
      placeholder: this.hasPlaceholderValue,
      placeholderValue: this.hasPlaceholderValue ? this.placeholderValue : undefined,
      searchPlaceholderValue: this.hasPlaceholderValue ? this.placeholderValue : '',
      removeItemIconText: '×',
      removeItemLabelText: '',
      removeItemButton: true,
    }

    if (this.inputValue) {
      choices_options.addItems = true;
      choices_options.items = this.selectedOptionsValue;
    }

    const attributeElementId = this.attributeElementIdValue;

    if (attributeElementId && document.getElementById(attributeElementId)) {
      const selectEl = document.getElementById(attributeElementId)
      const hadExplicitSelection = selectEl.querySelector('option[selected]') !== null

      const choicesInstance = new Choices(`#${attributeElementId}`, choices_options);
      this.element.choicesInstance = choicesInstance;

      if (this.hasPlaceholderValue) {
        if (!hadExplicitSelection) {
          choicesInstance.removeActiveItems()
        }
      }

      if (this.hasPlaceholderValue || this.clearableValue) {
        const form = selectEl.closest('form')
        if (form) {
          form.addEventListener('formdata', (event) => {
            const val = choicesInstance.getValue(true)
            const isEmpty = Array.isArray(val) ? val.length === 0 : !val
            if (isEmpty) {
              event.formData.set(selectEl.name, '')
            }
          })
        }
      }

      // Always add title tooltips to dropdown items when dropdown opens
      document.getElementById(attributeElementId).addEventListener('showDropdown', () => {
        setTimeout(() => this.addTitlesToDropdown(), 50);
      });

      if (this.hasResourceTypesValue) {
        if (Object.keys(this.resourceTypesValue).length > 0) {
          setTimeout(() => {
            this.addIconsToPills();
            this.addIconsToDropdown();
          }, 100);
        }

        document.getElementById(attributeElementId).addEventListener('addItem', () => {
          if (Object.keys(this.resourceTypesValue).length > 0) {
            setTimeout(() => this.addIconsToPills(), 50);
          }
        });

        document.getElementById(attributeElementId).addEventListener('showDropdown', () => {
          if (Object.keys(this.resourceTypesValue).length > 0) {
            setTimeout(() => this.addIconsToDropdown(), 50);
          }
        });
      }
    }
  }

  addIconsToPills() {
    // Find selected pills by their data attributes
    let pills = this.element.querySelectorAll('[data-item][data-value]');

    if (pills.length === 0) {
      pills = this.element.querySelectorAll('.choices__item:not(.choices__item--choice)');
    }

    pills.forEach(pill => {
      const value = pill.getAttribute('data-value');
      const resourceType = this.getResourceType(value);

      if (resourceType && !pill.querySelector('svg')) {
        const iconHTML = this.getIconForType(resourceType);
        if (iconHTML) {
          // Create a temporary div to parse the HTML
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = iconHTML;
          const iconElement = tempDiv.firstElementChild;

          // Insert the icon as the first child of the pill
          pill.insertBefore(iconElement, pill.firstChild);

          // Apply color classes based on resource type
          const colorClasses = this.getColorClassesForType(resourceType);
          pill.classList.remove('!bg-gray-200', '!border-gray-400', '!text-gray-800');
          colorClasses.split(' ').forEach(cls => {
            pill.classList.add('!' + cls);
          });
        }
      }

      if (this.isPublicVideoResource(value)) {
        this.addPublicAccessIcon(pill)
      }
    });
  }

  addIconsToDropdown() {
    const dropdownItems = this.element.querySelectorAll('.choices__item--choice[data-value]');
    dropdownItems.forEach(item => {
      const value = item.getAttribute('data-value');
      const resourceType = this.getResourceType(value);

      if (resourceType && !item.querySelector('svg')) {
        const iconHTML = this.getIconForType(resourceType);
        if (iconHTML) {
          // Create a temporary div to parse the HTML
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = iconHTML;
          const iconElement = tempDiv.firstElementChild;

          // Insert the icon as the first child
          item.insertBefore(iconElement, item.firstChild);

          // Add subtle color hint to dropdown items
          if (resourceType === 'VideoResource') {
            item.style.borderLeft = '3px solid rgb(147, 51, 234)'; // purple-600
          } else if (resourceType === 'AudioResource') {
            item.style.borderLeft = '3px solid rgb(37, 99, 235)'; // blue-600
          } else if (resourceType === 'DailySchedule') {
            item.style.borderLeft = '3px solid rgb(13, 148, 136)'; // bluegreen-600
          } else if (resourceType === 'Collection') {
            item.style.borderLeft = '3px solid rgb(5, 150, 105)'; // olive-600
          } else if (resourceType === 'CollectionGroup') {
            item.style.borderLeft = '3px solid rgb(249, 115, 22)'; // orange-600
          } else if (resourceType === 'DocumentResource') {
            item.style.borderLeft = '3px solid rgb(234, 88, 12)'; // orange-600
          } else if (resourceType === 'LinkResource') {
            item.style.borderLeft = '3px solid rgb(22, 163, 74)'; // green-600
          }
        }
      }

      if (this.isPublicVideoResource(value)) {
        this.addPublicAccessIcon(item)
      }
    });
  }

  addTitlesToDropdown() {
    const dropdownItems = this.element.querySelectorAll('.choices__item--choice[data-value]');
    dropdownItems.forEach(item => {
      // Get the text content, excluding any SVG icon text
      const textContent = item.textContent?.trim();
      if (textContent && !item.hasAttribute('title')) {
        item.setAttribute('title', textContent);
      }
    });
  }

}
